import type { ReactElement } from 'react'
import { Container } from '@/components/ui/container'

interface PageFooterProps {
	startSlot?: ReactElement
	centerSlot?: ReactElement
	endSlot?: ReactElement
}

export const PageFooter = ({
	startSlot,
	centerSlot,
	endSlot
}: PageFooterProps) => {
	return (
		<footer className='h-[74px] border-neutral-200 border-t bg-neutral-white'>
			<Container
				className='grid grid-cols-3 items-center text-neutral-700 text-sm [&>*:first-child]:justify-self-start [&>*:last-child]:justify-self-end [&>*:nth-child(2)]:justify-self-center'
				fullWidth
			>
				{startSlot ?? <div />}
				{centerSlot ?? <div />}
				{endSlot ?? <div />}
			</Container>
		</footer>
	)
}

PageFooter.displayName = 'PageFooter'
